import parse from 'utils/parse';

import type { ColorConfig } from './contracts';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'support-chat', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
});

const toastIds = {
  unexpectedError: Symbol('landingonline-support-chat-unexpected-error'),
};

const colorMap: ColorConfig = {
  messageSystemColor: '--landing-support-chat-message-system-text',
};

export { testId, toastIds, colorMap };
